import { combineReducers } from 'redux'
import {
  reducer as partnerReducer,
  reducerKey as partnerReducerKey,
} from './partners'
import {
  reducer as schoolReducer,
  reducerKey as schoolReducerKey,
} from './schools'
import {
  reducer as searchReducer,
  reducerKey as searchReducerKey,
} from './search'

import {
  reducer as artistReducer,
  reducerKey as artistReducerKey,
} from './teaching-artist'

const reducerKey = 'map'

const reducer = combineReducers({
  [partnerReducerKey]: partnerReducer,
  [schoolReducerKey]: schoolReducer,
  [artistReducerKey]: artistReducer,
  [searchReducerKey]: searchReducer,
})

export { reducer, reducerKey }
